module.exports = __webpack_public_path__ + "static/media/puzzle0202.263228d0.jpg";